import { createAction } from '@reduxjs/toolkit';

import type { CartBilling } from './cart_billing.types';

const get = {
  pending: createAction('cart/getBilling/pending'),
  fulfilled: createAction<CartBilling>('cart/getBilling/fulfilled'),
  rejected: createAction('cart/getBilling/rejected'),
};

export default {
  get,
};
